export enum BookingPlaceholderCandidateStatus {
	Pending = 1,
	Interested = 2,
	NotInterested = 3,
}
